<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <list-selector
          v-model="organization.modules"
          :selected-source="organization.modules"
          hint="selected_modules"
          autofocus
          return-object
          field-name="modules"
          source-type="modules"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EditOrganizationModules',
    props: {
      organization: Object,
    },
  }
</script>
